// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://61bcb8a99f3544a382f911e2d3d0ab13@o1223220.ingest.sentry.io/4504196427874304',
  environment: process.env.SENTRY_ENV,
  release: process.env.BITBUCKET_COMMIT,
  ignoreErrors: ["TypeError: Cannot read properties of undefined (reading 'x')"],
  enabled: process.env.BITBUCKET_COMMIT !== undefined,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  sampleRate: Number(process.env.SENTRY_SAMPLE_RATE_WEBAPP) || 0.01,
  tracesSampleRate: Number(process.env.SENTRY_TRACE_SAMPLE_RATE_WEBAPP) || 0.001,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.001,
});
